// DrawflowEditor.jsx
import React, { useEffect, useRef } from "react";
import Drawflow from "drawflow";
import "drawflow/dist/drawflow.min.css";

import "../cssstyle/beautiful.css"; 
import { FaClock, FaChartLine, FaCogs, FaCheckCircle } from "react-icons/fa"; // import icons
const DrawflowEditor = () => {
  const editorRef = useRef(null); // container ref used by Drawflow
  const editorInstance = useRef(null); // Drawflow instance
  const dragItemRef = useRef(null); // holds the currently dragging node type

  useEffect(() => {
    if (!editorRef.current) return;

    // initialize Drawflow
    const editor = new Drawflow(editorRef.current);
    editor.start();
    editor.editor_mode = "edit";
    editorInstance.current = editor;

    
  // Check localStorage for saved Time node only
  const saved = localStorage.getItem("timeNode");
  if (saved) {
    try {
      editor.import(JSON.parse(saved));
    } catch (err) {
      console.warn("Failed to import Time node:", err);
    }
  } else {
    // Add default Time node
    addNewNode("time", 100, 50);
  }

    // Drag over / drop handlers on the precanvas (where nodes should be dropped)
  const precanvas = editor.precanvas || editorRef.current;
    if(!precanvas){
      return
    }

    const handleDragOver = (e) => {
      e.preventDefault();
    };

    const handleDrop = (e) => {
      e.preventDefault();
      const nodeType = e.dataTransfer.getData("node") || dragItemRef.current;
      if (!nodeType) return;

      // position calculation relative to precanvas
      const bounds = precanvas.getBoundingClientRect();
      const posX = Math.round(e.clientX - bounds.left);
      const posY = Math.round(e.clientY - bounds.top);

      addNewNode(nodeType, posX, posY);
      dragItemRef.current = null;
    };

    precanvas.addEventListener("dragover", handleDragOver);
    precanvas.addEventListener("drop", handleDrop);

    // cleanup
    return () => {
      try {
        precanvas.removeEventListener("dragover", handleDragOver);
        precanvas.removeEventListener("drop", handleDrop);
      } catch (err) {}
      editorInstance.current?.clear()
      editorInstance.current = null;
    };
  }, []);

  // Generic addNodes helper (used by sidebar buttons)
  const addNodes = (name, html, inputs = 1, outputs = 1, posX = 100, posY = 100, width =300) => {
const nodeId=    editorInstance.current?.addNode(
      name,
      inputs,
      outputs,
      posX,
      posY,
      name + "-class",
      {},
      html
    );

     // Set node width manually
     if(nodeId!==undefined){

     
  const nodeElement = document.getElementById(`node-${nodeId}`);
  if (nodeElement) nodeElement.style.width = `${width}px`;

  };
}

  // Detailed node templates using Tailwind classes
  const templates = {
 time: () => `

 <div class = "w-full rounded flex flex-col "></div>

  <div class="w-full p-3 bg-gray-100 border-t border-gray flex items-center gap-2">
  <span class="text-gray-600 mr-1">⏰</span>
  <span class="font-semibold">Time Frame</span>
</div>
  <div class="w-full flex rounded-b items-start justify-start bg-white p-2 shadow-sm text-xs gap-4 flex-wrap">
    <!-- Header -->
  

    <!-- Start Time -->
    <div class="flex flex-col w-[150px]">
      <label class="text-xs mb-1">Start</label>
      <input type="text" class="rounded border px-1 py-0.5 text-xs" placeholder="HH:MM" />
    </div>

    <!-- End Time -->
    <div class="flex flex-col  w-[150px]">
      <label class="text-xs mb-1">End</label>
      <input type="text" class="rounded border px-1 py-0.5 text-xs "  placeholder="HH:MM" />
    </div>

    <!-- Mode Select -->
    <div class="flex flex-col  w-[150px]">
      <label class="text-xs mb-1">Mode</label>
      <select class="rounded border px-1 py-0.5 text-xs">
        <option class= "bg-white" value="live">Live</option>
        <option class= "bg-white" value="backend">Backend</option>
      </select>
    </div>

    <!-- Close Checkbox -->
    <div class="flex flex-col items-center w-[150px]  p-2">
      <label class="flex items-center text-xs m-1">
        <input type="checkbox" class="mr-1" /> Close
      </label>
    </div>
  </div>
`
  ,
  indicator: () => `
  <div class = "w-full  rounded">
    <div class="w-full rounded-t p-3 bg-gray-100 border-b flex items-center gap-2">
  <span>📈</span>
  <span class="font-semibold">Indicator</span>
</div>

  <div class="p-3 w-full bg-white rounded-b shadow-sm flex flex-wrap gap-4 text-xs">
  
    <!-- Indicator Type -->
    <div class="flex flex-col min-w-[120px] flex-1">
      <label class="font-semibold mb-1">Select Indicator</label>
      <select class="border rounded px-2 py-1">
        <option class= "bg-white" value="SMA">SMA</option>
        <option class= "bg-white" value="EMA">EMA</option>
        <option class= "bg-white" value="RSI">RSI</option>
        <option class= "bg-white" value="VWAP">VWAP</option>
      </select>
    </div>

    <!-- Period -->
    <div class="flex flex-col min-w-[100px] flex-1">
      <label class="font-semibold mb-1">Period</label>
      <input type="number" placeholder="Period" class="border rounded px-2 py-1" />
    </div>

    <!-- Source (Open / High / Low / Close etc.) -->
    <div class="flex flex-col min-w-[120px] flex-1">
      <label class="font-semibold mb-1">Source</label>
      <select class="border rounded px-2 py-1">
        <option class= "bg-white" value="open">Open</option>
        <option class= "bg-white" value="high">High</option>
        <option  class= "bg-white" value="low">Low</option>
        <option class= "bg-white" value="close">Close</option>
        <option class= "bg-white" value="hl2">HL2 (High+Low / 2)</option>
        <option class= "bg-white" value="hlc3">HLC3 (High+Low+Close / 3)</option>
        <option class= "bg-white" value="ohlc4">OHLC4 (Open+High+Low+Close / 4)</option>
      </select>
    </div>

    <!-- Unique ID -->
    <div class="flex flex-col min-w-[100px] flex-1">
      <label class="font-semibold mb-1">Unique ID</label>
      <input type="text" placeholder="ID" class="border rounded px-2 py-1" />
    </div>

  </div>
 </div>

    `,
    analyzer: () => `
     <div class = "w-full  rounded">
   <div class="w-full rounded-t p-3 bg-gray-100 border-b flex items-center gap-2">
  <span>⚙️</span>
  <span class="font-semibold">Analyzer</span>
</div>

      <div class="p-3 w-full bg-white rounded-b shadow-sm text-xs">
     
     
        <label class="block text-xs font-semibold mb-1">Analyzer</label>
        <textarea class="w-full border rounded px-2 py-1 text-xs" rows="3" placeholder="notes..."></textarea>
      </div>
      </div>
    `,
  condition: () => `
  <div class = "w-full  rounded">
   <div class="w-full rounded-t p-3 bg-gray-100 border-b flex items-center gap-2">
  <span>✅</span>
  <span class="font-semibold">Condition Match</span>
</div>

  <div class="p-3 w-full bg-white rounded-b shadow-sm text-xs">
  
    <label class="block font-semibold mb-1">Unique Id</label>
    <select class="w-full border rounded px-2 py-1 mb-2 condition-left-id">
      <option value="">Select Indicator ID</option>
      <!-- Dynamically filled later -->
    </select>

    <label class="block font-semibold mb-1">Condition</label>
    <select class="w-full border rounded px-2 py-1 mb-2 condition-operator">
      <option class= "bg-white" value="<"><</option>
      <option class= "bg-white" value=">">></option>
      <option class= "bg-white" value="==">==</option>
      <option class= "bg-white" value="!=">!=</option>
    </select>

    <label class="block font-semibold mb-1">Unique Id</label>
    <select class="w-full border rounded px-2 py-1 mb-2 condition-right-id">
      <option value="">Select Indicator ID / Value</option>
      <!-- Dynamically filled later -->
    </select>
</div>
  
  </div>
`,

  };

  // Add new node by type (mapping from HTML example)
  const addNewNode = (name, pos_x = 100, pos_y = 100) => {
    switch (name) {
      case "time":
        addNodes("TimeNode", templates.time(), 0, 0, pos_x, pos_y,700);
        break;
      case "indicator":
        addNodes("ContractType", templates.indicator(), 0, 1, pos_x, pos_y,300);
        break;
      case "analyzer":
        addNodes("Analyzer", templates.analyzer(), 1, 1, pos_x, pos_y,300);
        break;
      case "condition":
        addNodes("Condition", templates.condition(), 1, 1, pos_x, pos_y,300);
        break;
      default:
        addNodes("Node", `<div class="p-2 bg-white">Unknown</div>`, 1, 1, pos_x, pos_y,300);
    }
  };

  // Sidebar drag start
  const onDragStart = (e, nodeType) => {
    e.dataTransfer.setData("node", nodeType);
    dragItemRef.current = nodeType; // fallback for some browsers
  };

  // Save / Import / Export / Clear
  const saveFlow = () => {
    const data = editorInstance.current?.export();
    if (data) localStorage.setItem("drawflow", JSON.stringify(data));
    alert("Saved to localStorage");
  };

  const importFlow = () => {
    const data = localStorage.getItem("drawflow");
    if (!data) return alert("No saved flow found");
    try {
      editorInstance.current?.import(JSON.parse(data));
      alert("Imported saved flow");
    } catch (err) {
      console.error(err);
      alert("Failed to import flow");
    }
  };

  const exportFlow = () => {
    const data = editorInstance.current?.export();
    console.log("Exported JSON:", data);
    // optionally copy to clipboard:
    try {
      navigator.clipboard?.writeText(JSON.stringify(data, null, 2));
      alert("Exported JSON copied to clipboard");
    } catch (err) {}
  };

  const clearFlow = () => {
    if (!editorInstance.current) return;
    editorInstance.current.clear();
  };

  // quick add via sidebar buttons (not drag)
  const quickAdd = (type) => {
    // add near top-left (100,100) - user can move later
    addNewNode(type, 100, 100);
  };

  return (
    <div className="flex h-full min-h-[400px]">

       
      {/* Sidebar */}
      <div className="w-56 bg-gray-50 border-r border-gray-200 p-3">
      <h4 className="font-semibold mb-3 text-sm">Modules</h4>

      <div className="flex flex-col ">
        {/* Time */}
        <div
          draggable
          onDragStart={(e) => onDragStart(e, "time")}
          className="cursor-grab p-3 bg-white border hover:shadow text-sm flex items-center gap-2"
        >
          <FaClock className="text-gray-600" />
          <span>Time</span>
        </div>

        {/* Indicator */}
        <div
          draggable
          onDragStart={(e) => onDragStart(e, "indicator")}
          className="cursor-grab p-3 bg-white border hover:shadow text-sm flex items-center gap-2"
        >
          <FaChartLine className="text-gray-600" />
          <span>Indicator</span>
        </div>

        {/* Analyzer */}
        <div
          draggable
          onDragStart={(e) => onDragStart(e, "analyzer")}
          className="cursor-grab p-3 bg-white border hover:shadow text-sm flex items-center gap-2"
        >
          <FaCogs className="text-gray-600" />
          <span>Analyzer</span>
        </div>

        {/* Condition */}
        <div
          draggable
          onDragStart={(e) => onDragStart(e, "condition")}
          className="cursor-grab p-3 bg-white border hover:shadow text-sm flex items-center gap-2"
        >
          <FaCheckCircle className="text-gray-600" />
          <span>Condition</span>
        </div>
      </div>
  

        <div className="mt-4 flex flex-col gap-2">
          {/* <button
            onClick={() => quickAdd("time")}
            className="py-2 rounded bg-blue-500 text-white text-sm"
          >
            + Add Time Node
          </button> */}
          {/* <button
            onClick={() => quickAdd("contract")}
            className="py-2 rounded bg-blue-500 text-white text-sm"
          >
            + Add Contract Node
          </button> */}

       
        </div>
      </div>

      {/* Canvas */}
      <div className="flex-1 relative">

        
        <div
          ref={editorRef}
          id="drawflow"
          className="w-full h-[70vh] bg-white"
          style={{ minHeight: 300 }}
        />
        {/* instruction */}
        <div className="absolute top-3 left-3 text-xs text-gray-500">
          Drag items from left and drop on canvas
        </div>

          {/* <div className="mt-4 ">
            <button onClick={saveFlow} className="mr-2 py-1 px-3 rounded bg-gray-200 text-xs">
              💾 Save
            </button>
           
            <button onClick={exportFlow} className="mr-2 py-1 px-3 rounded bg-gray-200 text-xs">
              📤 Export
            </button>
           
          </div> */}
      </div>
    </div>
  );
};

export default DrawflowEditor;
